import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaFilePdf, FaLink } from "react-icons/fa";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function ProjctReport() {
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        setLoading(true);
        setError(null);
        try {
            const url = process.env.REACT_APP_API + "/viewweb/report";
            const res = await axios.get(url, { credentials: true });
            if (!res.status === 200) throw new Error(`Failed to fetch documents: ${res.status} ${res.statusText}`);
            setDocs(Array.isArray(res?.data?.data) ? res?.data?.data : []);
        } catch (err) {
            setError(err.message || "Unknown error");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="max-w-6xl mx-auto p-6">
            <h2 className="text-3xl font-semibold mb-6 text-center text-[#1050A2]">
                Project Report
            </h2>

            {/* Loading State */}
            {loading && (
                <div className="py-10 text-center text-gray-600 animate-pulse">
                    Loading documents...
                </div>
            )}

            {/* Error State */}
            {error && (
                <div className="bg-red-100 border border-red-300 text-red-700 px-4 py-3 rounded-lg mb-4 shadow-sm">
                    {error}
                </div>
            )}

            {/* No Documents */}
            {!loading && !error && docs.length === 0 && (
                <div className="text-gray-500 py-10 text-center italic">
                    No E-Resourcess available yet.
                </div>
            )}

            {/* Table */}
            {docs.length > 0 && (
                    <table className="min-w-full divide-y divide-gray-300">
                        <thead className="bg-[#1050A2]/90 text-white">
                            <tr>
                                <th className="px-4 py-3 text-center text-sm font-semibold">#</th>
                                <th className="px-4 py-3 text-center text-sm font-semibold">Title</th>
                                <th className="px-4 py-3 text-center text-sm font-semibold">Link</th>
                                <th className="px-4 py-3 text-center text-sm font-semibold">File</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-200 bg-white/70">
                            {docs.map((doc, idx) => (
                                <motion.tr
                                    key={doc.id}
                                    whileHover={{  backgroundColor: "rgba(240,249,255,0.7)" }}
                                    transition={{ duration: 0.2 }}
                                    className="cursor-pointer"
                                >
                                    <td className="px-4 py-3 text-center text-gray-700 font-medium">
                                        {idx + 1}
                                    </td>
                                    <td className="px-4 py-3 text-gray-900 font-medium">{doc.title}</td>
                                    <td className="px-4 py-3 text-center">
                                        <Link
                                            to={doc.link}
                                            className="inline-flex items-center justify-center w-8 h-8 bg-blue-100 hover:bg-blue-200 rounded-full transition"
                                        >
                                            <FaLink className="text-blue-600" />
                                        </Link>
                                    </td>
                                    <td className="px-4 py-3 text-center">
                                        <Link
                                            target="_blank"
                                            to={doc.pdf}
                                            className="inline-flex items-center justify-center w-8 h-8 bg-red-100 hover:bg-red-200 rounded-full transition"
                                        >
                                            <FaFilePdf className="text-red-600"/>
                                        </Link>
                                    </td>
                                </motion.tr>
                            ))}
                        </tbody>
                    </table>
            )}
        </div>
    );
}
